import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

const FILTER_OPTIONS = [
  {
    id: "true",
    name: "Active",
  },
  {
    id: "false",
    name: "Deactivated",
  },
];

export function StatusFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      label={t("Status")}
      selectedKeys={params.is_active?.split(",") || []}
      onSelectionChange={(keys) => setParam("is_active", Array.from(keys))}
      items={FILTER_OPTIONS}
      showActionBar
      selectionMode="single"
      testID="apply-link-status-filter"
    />
  );
}
